export const tipoContatoModel = {
  tipoContato: function () {
    return {
      descricao: '',
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/TipoContato/_model/tipoContato.js